import type { SSIFormData, SSIApiResponse, SSIErrorResponse } from './types';

/**
 * Type predicate para estreitar `SSIApiResponse`.
 *
 * `strictNullChecks` está desabilitado no tsconfig, e sem ele o TypeScript
 * não estreita união discriminada por booleano literal — `if (result.success)`
 * não elimina o membro de sucesso do ramo contrário. O predicado funciona
 * independente dessa configuração.
 */
export function isSsiFailure(
  response: SSIApiResponse
): response is SSIErrorResponse {
  return response.success === false;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';

export async function analyzeSsi(input: SSIFormData): Promise<SSIApiResponse> {
  const payload = {
    cargo_atual: input.cargo_atual,
    area_interesse: input.area_interesse,
    texto_sobre: input.texto_sobre,
    pilares: input.pilares.map((p) => ({ number: p.number, score: Number(p.score) })),
  };

  try {
    const res = await fetch(`${API_BASE_URL}/ssi/analyze/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (res.ok) {
      return { success: true, report: data.report ?? '' };
    }

    return {
      success: false,
      code: data.code ?? 'API_ERROR',
      message: data.message,
      errors: data.errors,
    };
  } catch {
    return {
      success: false,
      code: 'NETWORK_ERROR',
      message: 'Erro de conexão. Verifique sua internet.',
    };
  }
}
